/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';
import { Popover, ArrowContainer } from "react-tiny-popover";
import { CustomRadioBtn } from "./CustomRadioButton/CustomRadioButton";

interface ISelectOption {
    displayValue: string;
    internalValue: string | number;
}

export interface ISelectPopverOptions extends ISelectOption {
    children?: ISelectOption[];
}


interface ISelectPopoverProps {
    dropdownOptions: ISelectPopverOptions[];
    isMultiple?: boolean;
    showRadioButtonDisplay?: boolean;
    showFooterCTA?: boolean
    showTooltipIcon?: boolean;
    clickLabel: string;
    clickLabelStyles: any;
    selectedOption: string | number;
    handleOptionSelection: (selectedOptionValue: string | number, isChildOptionSelected?: boolean) => void;
    popoverPlacement: "top" | "bottom" | "left" | "right";
    footer?: any;
    customStyles?: any;
    showCloseIcon?: any;
}


export const CustomPopover: React.FC<ISelectPopoverProps> = (props: ISelectPopoverProps) => {
    const { dropdownOptions, isMultiple, showTooltipIcon, clickLabel, clickLabelStyles, handleOptionSelection, selectedOption, showRadioButtonDisplay, showFooterCTA, popoverPlacement, footer, customStyles, showCloseIcon } = props;

    const [isMainPopoverOpen, setMainPopoverDisplay] = React.useState(false);

    const [isChildPopoverOpen, setChildPopoverDisplay] = React.useState(false);

    const handleSelection = (selectedOption: ISelectPopverOptions) => {
        if (!selectedOption.children) {
            handleOptionSelection(selectedOption.internalValue);
            setMainPopoverDisplay(false);
        }
    }

    const handleChildOptionSelection = (selectedOption: ISelectOption) => {
        handleOptionSelection(selectedOption.internalValue, true);
        setChildPopoverDisplay(false);
        setMainPopoverDisplay(false);
    }

    const getSelectPopverDisplay = () => {
        return (
            //check if option has children, show another popover on click else choose the selected option
            <React.Fragment>
                <div css={styles.selectLabel}>Select</div>
                {dropdownOptions.map((option, index) => {
                    const isOptionCascading = option.children && option.children.length > 0;
                    return (
                        <div css={styles.optionWrapper} key={`option-${index}`} onClick={() => handleSelection(option)} >
                            {!option.children && selectedOption === option.internalValue && <img src="/images/Tick_3.svg" alt="selected" css={styles.tickIcon} />}
                            {
                                !isOptionCascading ? <div css={styles.selectOption}>{option.displayValue}</div> : (
                                    <Popover
                                        isOpen={isChildPopoverOpen}
                                        positions={['right']}
                                        padding={3}
                                        onClickOutside={() => setChildPopoverDisplay(false)}
                                        content={() => (
                                            <div css={styles.popoverWrapper}>
                                                {
                                                    option.children.map((childOption, index) => {
                                                        const hasSemicolon = childOption.displayValue.indexOf(":");
                                                        const splitValue = hasSemicolon && childOption.displayValue.split(":");
                                                        return (
                                                            <div key={`child-${index}`} css={styles.optionWrapper} onClick={() => handleChildOptionSelection(childOption)}>
                                                                {
                                                                    hasSemicolon ? (
                                                                        <React.Fragment>
                                                                            <span css={styles.childValue}>{splitValue[0]} : </span>
                                                                            <span css={styles.additonalValue}>{splitValue[1]}</span>
                                                                        </React.Fragment>
                                                                    ) :
                                                                        <div css={styles.selectOption}>{childOption.displayValue}</div>
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )}
                                    >
                                        <div css={styles.selectOption} onClick={() => setChildPopoverDisplay(true)}>
                                            {option.displayValue}
                                            <span onClick={() => setChildPopoverDisplay(true)} css={styles.arrowIcon} />
                                        </div>
                                    </Popover>
                                )
                            }
                        </div>
                    )
                })
                }
            </React.Fragment >)
    }

    const getContent = () => {
        if (isMultiple) {
            //add multiple selection logic
        }
        else if (showRadioButtonDisplay) {
            return <CustomRadioBtn options={dropdownOptions} handleClick={handleOptionSelection} showCTA={showFooterCTA} footer={footer} />
        }
        else {
            return getSelectPopverDisplay()
        }
    }

    const getOuterWrapper = () => {
        return (
            <div>
                <div css={{ ...styles.popoverWrapper, ...customStyles }}>
                    {showCloseIcon && <div onClick={() => setMainPopoverDisplay(false)} css={styles.crossIcon}>x</div>}
                    {getContent()}
                </div>
            </div>
        )
    }

    return (
        <Popover
            isOpen={isMainPopoverOpen}
            positions={[popoverPlacement]}
            padding={10}
            onClickOutside={() => setMainPopoverDisplay(false)}
            content={({ position, childRect, popoverRect }) => (
                showTooltipIcon ? (
                    <ArrowContainer
                        position={position}
                        childRect={childRect}
                        popoverRect={popoverRect}
                        arrowColor={"white"}
                        arrowSize={10}
                    >
                        {getOuterWrapper()}
                    </ArrowContainer>
                ) : getOuterWrapper()
            )}
        >
            <div css={clickLabelStyles} onClick={() => setMainPopoverDisplay(true)}>{clickLabel}</div>
        </Popover>
    )
}